/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Has_Publish_Date_UnsetInputs */

const cs_blog_filter_has_publish_date_unset = /** @type {(inputs: Blog_Filter_Has_Publish_Date_UnsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ještě nepublikováno`)
};

const en_blog_filter_has_publish_date_unset = /** @type {(inputs: Blog_Filter_Has_Publish_Date_UnsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not published yet`)
};

/**
* | output |
* | --- |
* | "Not published yet" |
*
* @param {Blog_Filter_Has_Publish_Date_UnsetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_has_publish_date_unset = /** @type {((inputs?: Blog_Filter_Has_Publish_Date_UnsetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Has_Publish_Date_UnsetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_has_publish_date_unset(inputs)
	return cs_blog_filter_has_publish_date_unset(inputs)
});